
import model from '_core/newModel';

const searchSuggestion = {

  /*
  ==================================================
   CRUD METHODS (returns promises)
  ==================================================
  */

  index(domain='genome') {
    const path = `market/web/${domain}/suggestions`;
    return model.index(path);
  },

  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */

};

export default searchSuggestion;
